import { Accordion as MAccordion, AccordionDetails as MAccordionDetails, AccordionSummary as MAccordionSummary, } from '@mui/material';
import styled from 'styled-components';
import { theme } from '../../themes/theme';
export const Accordion = styled(MAccordion) `
  &&.MuiPaper-root{
    border:${({ withborder }) => withborder === 'false' && 'none'}};
  }
  &&.MuiPaper-elevation1 {
    box-shadow:${({ withborder }) => withborder === 'false' && 'none'}};
  }
  &&.MuiAccordion-root.Mui-disabled {
    background: none;
  }
`;
export const AccordionDetails = styled(MAccordionDetails) `
  &&.MuiAccordionDetails-root {
    flex-direction: column;
    padding: 0.5rem 0;
  }
`;
export const AccordionSummary = styled(MAccordionSummary) `
  &&.MuiAccordionSummary-root {
    margin-top: 0.75rem;
    height: 3rem;
    padding-bottom: 0.75rem;
    border-bottom: 1px solid ${theme.palette.divider};
  }
  &&.MuiAccordionSummary-root.Mui-expanded {
    min-height: unset;
  }
`;
